import React from 'react';

import { QBox, QText } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';

const NotFound: React.FC = () => {
  const { t } = useTranslation();
  return (
    <QBox>
      <QText>{t('notFound.message')}</QText>
    </QBox>
  );
};

export default NotFound;
